let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2QQ3K")).then(() => parcelRequire('9DwAy'));